var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 9.5,
    fill: "#81BD47"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3826 8.27344H15.2834C15.0443 8.27344 14.817 8.38828 14.6764 8.58516L10.992 13.6945L9.32325 11.3789C9.18262 11.1844 8.95762 11.0672 8.71621 11.0672H7.617C7.46465 11.0672 7.37559 11.2406 7.46465 11.3648L10.385 15.4148C10.454 15.5111 10.5449 15.5896 10.6503 15.6437C10.7556 15.6978 10.8724 15.7261 10.9908 15.7261C11.1093 15.7261 11.226 15.6978 11.3314 15.6437C11.4368 15.5896 11.5277 15.5111 11.5967 15.4148L16.5326 8.57109C16.624 8.44688 16.535 8.27344 16.3826 8.27344V8.27344Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM12 20.7188C7.18594 20.7188 3.28125 16.8141 3.28125 12C3.28125 7.18594 7.18594 3.28125 12 3.28125C16.8141 3.28125 20.7188 7.18594 20.7188 12C20.7188 16.8141 16.8141 20.7188 12 20.7188Z",
    fill: "#81BD47"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.ddbfe59eebc62bbf166b9797b1f54203.svg";
export { ForwardRef as ReactComponent };